import React from 'react'
import { Skeleton, SkeletonProps } from '@mui/material'

const SkeletonTextField: React.FC<SkeletonProps> = (props: SkeletonProps) => {
  return <Skeleton variant='rectangular' width='100%' height={55} {...props} />
}

export default SkeletonTextField
